// src/components/shared/StyledComponents.js
import { styled } from '@mui/material/styles';
import { Button, Card, Typography } from '@mui/material';

// -- Pill Button (for top nav items) --
export const PillButton = styled(Button)(({ theme }) => ({
  borderRadius: 50,
  textTransform: 'none',
  padding: '6px 16px',
  fontWeight: 500,
  marginRight: theme.spacing(1.5),
}));

// -- Black circle with "X" in it --
export const NavIconCircle = styled('div')(({ theme }) => ({
  width: 36,
  height: 36,
  borderRadius: '50%',
  backgroundColor: '#000',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

export const XMark = styled('span')(() => ({
  color: '#fff',
  fontWeight: 'bold',
  fontSize: 18,
}));

// -- Rounded Card --
export const RoundedCard = styled(Card)(({ theme }) => ({
  borderRadius: 20,
  padding: theme.spacing(2),
  boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
  border: '1px solid #e6e6e6',
}));

// -- Card Title --
export const CardTitle = styled(Typography)(() => ({
  fontWeight: 600,
  fontSize: 15,
  color: '#444',
  marginBottom: 8,
}));

// -- Big Value text --
export const BigValue = styled(Typography)(() => ({
  fontWeight: 700,
  fontSize: 20,
  color: '#222',
}));
